import dynamic from 'next/dynamic'
import { DemographicsIcon } from 'src/components/insights/icons/demographics'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/housing-units.png'

const DemographicsHousingUnits = dynamic(() => import('src/components/insights/demographics/cards/housing-units'), {
  ssr: false,
})

export const DemographicsHousingUnitsWidget: InsightBuilderWidget = {
  id: 'housing-units',
  name: 'Housing Units',
  type: 'Demographics',
  icon: DemographicsIcon,
  component: DemographicsHousingUnits,
  supportedResultTypes: ['alphamap-location'],
  preview,
}
